// Withdrawing a pending suggestion (C-14). Company facts proposed from meetings
// were retired with the knowledge wiki (D69); only this label is still used.
//
// Namespace `meetings-knowledge`; owner WP-7 (BUILD 1). Only the owner adds keys or
// translations. Placeholders are `{name}`, filled with `formatCopy`. See ./index.ts.
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  withdraw: 'Withdraw',
};

export type MeetingsKnowledgeCopyKey = keyof typeof en;

const meetingsKnowledgeCopy: NamespaceCatalog<MeetingsKnowledgeCopyKey> = {
  bg: {
    withdraw: 'Оттегли',
  },
  hr: {
    withdraw: 'Povuci',
  },
  cs: {
    withdraw: 'Stáhnout',
  },
  da: {
    withdraw: 'Træk tilbage',
  },
  nl: {
    withdraw: 'Intrekken',
  },
  en,
  et: {
    withdraw: 'Võta tagasi',
  },
  fi: {
    withdraw: 'Peru',
  },
  fr: {
    withdraw: 'Retirer',
  },
  de: {
    withdraw: 'Zurückziehen',
  },
  el: {
    withdraw: 'Απόσυρση',
  },
  hu: {
    withdraw: 'Visszavonás',
  },
  ga: {
    withdraw: 'Tarraing siar',
  },
  it: {
    withdraw: 'Ritira',
  },
  lv: {
    withdraw: 'Atsaukt',
  },
  lt: {
    withdraw: 'Atšaukti',
  },
  mt: {
    withdraw: 'Irtira',
  },
  pl: {
    withdraw: 'Wycofaj',
  },
  pt: {
    withdraw: 'Retirar',
  },
  ro: {
    withdraw: 'Retrage',
  },
  sk: {
    withdraw: 'Stiahnuť',
  },
  sl: {
    withdraw: 'Umakni',
  },
  es: {
    withdraw: 'Retirar',
  },
  sv: {
    withdraw: 'Dra tillbaka',
  },
};

export default meetingsKnowledgeCopy;
